/**
 * Injects HTML links into a text
 * @param text - The text to inject the links into
 * @param links - The links to inject into the text
 * @returns The text with the links injected into it
 * @example
 * injectHtmlLinksInText('Hello {{link}}', ['https://www.google.com'])
 * // returns 'Hello <a href="https://www.google.com" target="_blank" class="text-secondary font-bold underline" rel="noopener noreferrer">link</a>'
 */
export const injectHtmlLinksInText = (text: string, links: string[]) => {
  // security return text if no links avaliable
  if (!links) return text;
  let processedText = text;
  // we first find all the {{content}} and replace them with the link
  const matches = processedText.match(/{{.*?}}/g);
  if (matches) {
    matches.forEach((match, i) => {
      const link = links[i];
      const linkText = match.replace(/{{|}}/g, ''); // we remove the {{}} from the match
      processedText = processedText.replace(
        match,
        `<a href="${link}" target="_blank" class="text-secondary font-bold underline" rel="noopener noreferrer">${linkText}</a>`
      );
    });
  }
  return processedText;
};
